import app from 'flarum/forum/app';
import { CalWidgetSkeleton, measure } from './CalSkeleton';
import { forumPulse } from '../../common/api';
import { bind } from '../../common/widgetData';
import { num } from '../../common/dates';
import { asUser } from '../../common/users';
import Avatar from 'flarum/common/components/Avatar';
const t = (k, p) => app.translator.trans('ernestdefoe-calendar.forum.' + k, p);
const DAY_MS = 86400000;
function ymd(d) {
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
function level(count, max) {
  if (!count) return 0;
  if (max <= 1) return 4;
  const q = count / max;
  return q > 0.75 ? 4 : q > 0.5 ? 3 : q > 0.25 ? 2 : 1;
}

/** Compact recent-activity mini grid (last `weeks` weeks). */
function miniGrid(days, max, weeks) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let cur = new Date(today.getTime() - (weeks * 7 - 1) * DAY_MS);
  cur = new Date(cur.getTime() - cur.getDay() * DAY_MS); // align to Sunday for the strip
  const cols = [];
  while (cur <= today) {
    const col = [];
    for (let i = 0; i < 7; i++) {
      if (cur > today) col.push(null);else {
        const k = ymd(cur);
        col.push({
          lvl: level(days[k] || 0, max)
        });
      }
      cur = new Date(cur.getTime() + DAY_MS);
    }
    cols.push(col);
  }
  return cols;
}

/**
 * "Forum Pulse" — the community heartbeat: a compact recent-activity heatmap plus
 * a most-active leaderboard. Self-contained POJO so it works on the stock index,
 * a Bespoke widget, or a Page Builder block. attrs: { title, weeks, count }.
 */
const PulseWidget = {
  oninit(vnode) {
    const a = vnode.attrs || {};
    const limit = Math.max(3, Number(a.count) || 5);
    bind(this, 'data', 'pulse:' + limit, () => forumPulse({
      days: 120,
      leaderDays: 30,
      limit
    }), {
      days: {},
      total: 0,
      max: 0,
      leaders: [],
      leaderDays: 30
    });
  },
  view(vnode) {
    const a = vnode.attrs || {};
    const title = a.title || t('pulse_title');
    const d = this.data;
    const weeks = Math.max(6, Math.min(20, Number(a.weeks) || 14));
    return m('.CalPulse', measure('CalPulse'), [m('.CalPulse-head', [m('h4.CalPulse-title', title), d ? m('span.CalPulse-total', t('pulse_total', {
      count: num(d.total)
    })) : null]), !d ? m(CalWidgetSkeleton, {
      block: 'CalPulse',
      bar: 'CalPulse-skel',
      rows: 4,
      fallback: 176
    }) : [m('.CalPulse-grid', miniGrid(d.days, d.max, weeks).map(col => m('.CalPulse-col', col.map(cell => cell ? m('span.CalHeat-cell', {
      'data-lvl': cell.lvl
    }) : m('span.CalHeat-cell.is-future'))))), d.leaders.length ? m('ol.CalPulse-board', d.leaders.map((l, i) => leaderRow(l, i))) : m('p.CalPulse-empty', t('pulse_empty'))]]);
  }
};
function leaderRow(l, i) {
  const user = asUser(l.userId, l);
  return m('li.CalPulse-leader', [m('span.CalPulse-rank', '#' + num(i + 1)), m('a.CalPulse-user', {
    href: app.route.user(user),
    oncreate: m.route.Link
  }, [
  // Core's Avatar on a real User model: the same face the member has
  // everywhere else on the forum. notranslate keeps a browser translating
  // the page from rewriting a lone initial ("E" -> "AND").
  m(Avatar, {
    user,
    className: 'CalPulse-avatar notranslate'
  }), m('span.CalPulse-name', user.displayName())]), m('span.CalPulse-count', num(l.count))]);
}
export default PulseWidget;
flarum.reg.add('ernestdefoe-calendar', 'forum/components/PulseWidget', PulseWidget);